/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */
import { getAppHeaders, getBuyerHeaders, getBuyersUrl, getSellerUrl } from 'shared/http';
import { getUTCTime, webcontent } from 'shared/settings/apiconfig';
import interfaceService from './interfaceService';


class CommonService {
    constructor() {
        this.service = interfaceService.getService();
    }

    commonPost(url, data, header) {
        return this.service.post(url, data, header);
    }

    getUtc() {
        return this.service.get(getBuyersUrl(getUTCTime), getBuyerHeaders());
    }

    webContentText(type) {
        return this.service.get(getSellerUrl(`${webcontent}${type}`), getAppHeaders());
    }
}

export default new CommonService();